import React from 'react';
import { Box } from '../../Box/Box';
import { Text } from '../../Text/Text';
/**
 * @public
 */
export const Note = ({
  children
}) => React.createElement(Box, {
  bg: 'background',
  p: 3,
  borderRadius: 'xl'
}, React.createElement(Text.span, {
  color: 'text.tint'
}, React.createElement(Text.span, {
  bold: true
}, "NOTE "), children));